import NoData from './NoData';
export { Props } from './NoData';
export default NoData;
